import React from 'react';
import {SimpleDialog} from "@components/form/SimpleDialog";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {Select} from '@components/form/Select'
import {LabelButton} from "@components/common/buttons/LabelButton";
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import { StyledMessageComponent } from "@components/common/messages/StyledMessageComponent";
const merge = require('deepmerge');
import {empty} from '~/utils/empty';

export class CombineOrdersComponent extends React.Component {
    initState = {
        form: {
            selectedOrder: '',
        },
        errors: {}
    };
    state = {
        open: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.state.open && this.state.open != prevProps.open) {
            if (this.props.mainOrder) {
                this.setState({
                    form: merge(this.state.form, {selectedOrder: this.props.mainOrder}),
                });
            } else if (this.state.open != prevProps.open) {
                this.setState({
                    ...this.initState,
                    form: merge(this.initState.form, {selectedOrder: this.props.mainOrder}),
                });
            }
        }
    }

    confirm = async() => {
        if (empty(this.state.form.selectedOrder)) {
            this.setState({errors: {order: ['Выберите заказ']}});
        } else {
            let response = await this.props.mergeOrderProducts(
                this.state.form.selectedOrder,
                (this.props.orders || []).filter(order => order !== this.state.form.selectedOrder)
            );
            if (response.errors && Object.keys(response.errors).length) {
                this.setState({errors: response.errors});
            } else {
                if (response.data) { //success
                    this.setState({open: false});
                    if (this.props.onSubmitRedirect) {
                        this.props.onSubmitRedirect(response)
                    } else this.props.tableRef.current.onQueryChange();
                }
            }
        }
    }

    render() {
        let { classes, orders} = this.props;

        return (<SimpleDialog
            fullWidth={true}
            maxWidth={'sm'}
            open={this.state.open}
            onClose={(e) => this.setState({open: false})}
            title='Объединение заказов'
            icon={<LabelButton
                onClick={e => this.setState({open: true})}
                title={'Объединить'}
                icon={<GroupWorkIcon color={'primary'}/>}
                disableMargin
            />}
            actions={[
                (<Button
                    onClick={(e) =>{this.confirm()}}
                    color="primary" variant="contained"
                >
                    Подтвердить
                </Button>),
            ]}
        >
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12}>
                    <StyledMessageComponent message="Товарные позиции из выбранных заказов будут объединены в основной заказ." />
                    <Select
                        label={'Основной заказ'}
                        name={'order'} 
                        options={orders.map(order => {return {value: order, label: `ID ${order}`}})}
                        value={this.state.form.selectedOrder} 
                        errors={this.state.errors}
                        onChange={({target: {value}}) => this.setState({form: {...this.state.form, selectedOrder: value}})}
                        displayEmpty
                        fullWidth
                        variant={'outlined'}
                        margin={'normal'}
                        className={classes.input}
                        size={'small'}
                    />              
                </Grid>
            </Grid>
        </SimpleDialog>)
    }
}